import React from "react";
import { VersionHistoryPanel } from "pages/PayRoll/Shared/statutoryConfigUi";
import { JOINER_COVER_OPTIONS, WITHIN_CEILING_OPTIONS, historyFormulaOf, optionLabel, periodLabel } from "./esiConfigData";

// Version History drawer (C1c) on the shared statutory panel: versions,
// changes from the previous version, who saved it, the payrolls that used
// it, and Compare versions.

const yesNo = (value) => (value ? "Yes" : "No");
const FIELDS = [
  ["wage_ceiling", "ESI wage ceiling (₹)"],
  ["disability_ceiling", "Disability ceiling (₹)", (value) => value || "Not used"],
  ["period1_start_month", "Period 1", periodLabel],
  ["period2_start_month", "Period 2", periodLabel],
  ["continue_to_period_end", "Stay covered until the period ends", yesNo],
  ["joiner_cover_from", "New joiner covered", (value) => optionLabel(JOINER_COVER_OPTIONS, value)],
  ["within_ceiling_cover_from", "Wage falls within ceiling mid-period", (value) => optionLabel(WITHIN_CEILING_OPTIONS, value)],
];

export const EsiVersionHistoryPanel = (props) => (
  <VersionHistoryPanel
    {...props}
    fields={FIELDS}
    formulaOf={historyFormulaOf}
    subtitle="ESI Configuration by month. A version used by a payroll is locked."
    note="A version used by a payroll is locked. To change anything, create a new version with a new effective date. Amounts use the version of the payroll month; coverage uses the version in force at the start of the contribution period."
  />
);
